//COMPASS2021-08-30
//增加“知识库”页面

//文件router/index.js
import {createRouter, createWebHistory} from "vue-router";
import Home from "../home/home.vue"
import Login from "../login/login.vue"
import HelloWorld from "@/components/HelloWorld";
import Issues from "../home/issue/issue"
import notFound from "../error/notFound"
import serveError from "../error/serveError"
import Welcome from "../home/welcome/welcome"
import NewUser from "../home/user/newuser"
import AddType from "../home/issue/addtype"
import AllUser from "../home/user/usershow";
import ExportIssue from "../home/issue/exportissue";
import Kbshow from "../home/kb/Kbshow" //COMPASS2021-08-30
import knowledgetype from '@/home/kb/knowledgetype'
import kbinfo from '@/home/kb/kbinfo'
import fileshow from "../home/file/fileshow"
import fileup from "../home/file/fileup"
import uploadtest from "../home/file/uploadtest"
import usercompany from '@/home/usercompany/usercompany'
import watcher from '@/home/watcher/watcher'
import kbreview from '@/home/kb/kbreview'
import showcharger from '@/home/emailcharger/showcharger'
import issuetrace from '@/home/issue/issuetrace'
import mainpage from '@/home/issue/mainpage'
import agent from '@/home/agent/showagent' //COMPASS2023-11-15
import customizedstatus from '@/home/issue/customizedstatus' //COMPASS2023-11-15
import dtlevel from '@/home/service/dtlevel' //COMPASS2023-11-15
import details from '@/login/details'
import showvaluechain from '@/home/service/showvaluechain'
import contact from '@/login/contact'
import help from '@/login/help'
import newkb from '@/home/kb/newkb'
import applyoutsider from '@/home/user/applyoutsider'
import outsider from '@/home/user/outsider'
import serialnoexport from '@/home/serialno/serialnoexport'
import unauthentication from '@/error/unauthentication'
import unauthorized from '@/error/unauthorized'
import material from '@/home/pcb/material'
import craft from '@/home/pcb/craft'
import chatAI from '@/home/chat/chatAI'
import purchase from '@/home/pcb/purchase'

import expertreview from '@/home/expert/expertreview'
import expertall from '@/home/expert/expertall'

/**
 * 创建路由对象
 */

/** 增加知识库
 * 2021-08-30
 * Julien
*/

const routes = [{
    path: '/',
    redirect: '/login'
},
    {
        path: '/404',
        name: '404',
        component: notFound
    },
    {
        path: '/500',
        name: '500',
        component: serveError
    },
    {
        path: '/unauthenticated',
        name: 'unauthenticated',
        component: unauthentication
    },
    {
        path: '/unauthorized',
        name: 'unauthorized',
        component: unauthorized
    },
    {
        path: '/home',
        name: 'home',
        // meta: {
        //     roles: ['管理员', '客服', '客户']
        // },
        component: Home,
        redirect: '/welcome',
        children:[{
            path: '/welcome',
            name: 'welcome',
            component: Welcome
        },{
            path: '/expertreview',
            name: 'expertreview',
            component: expertreview
        },{
            path: '/expertall',
            name: 'expertall',
            component: expertall
        },

        {
            path: '/issue',
            name: 'issue',
            component: Issues
        },{
            path: '/exportissue',
            name: 'exportissue',
            component: ExportIssue
        },{
           path: '/addtype',
           name: 'addtype',
           component: AddType
        },{
            path: '/newuser',
            name: 'newuser',
            // meta: {
            //     roles: ['管理员']
            // },
            component: NewUser
        },{
            path:'/usershow',
            name: 'usershow',
            // meta: {
            //     roles: ['管理员']
            // },
            component: AllUser
        },{
            path:'/outsider',
            name: 'outsider',
            component: outsider
        }, {
                path: '/kbshow',
                name: 'kbshow',
                component: Kbshow
        },{
            path: '/knowledgetype',
            name: 'knowledgetype',
            component: knowledgetype
        },{
            path: '/kbinfo',
            name: 'kbinfo',
            component: kbinfo
        },
        {
            path: '/kbreview',
            name: 'kbreview',
            component: kbreview
        },{
            path:'/fileshow',
            name: 'fileshow',
            // meta: {
            //     roles: ['管理员']
            // },
            component: fileshow   //import 文件目录
        },
        {
            path:'/fileup',
            name: 'fileup',
            // meta: {
            //     roles: ['管理员']
            // },
            component: fileup   //import 文件目录
        },
        {
            path:'/uploadtest',
            name: 'uploadtest',
            // meta: {
            //     roles: ['管理员']
            // },
            component: uploadtest   //import 文件目录
        },
        {  //公司管理
            path:'/usercompany',
            name:'usercompany',
            component: usercompany
        },
        {  //序列号管理
            path:'/serialnoexport',
            name:'serialnoexport',
            component: serialnoexport
        },
        {  //物料单价管理
            path:'/material',
            name:'material',
            component: material
        },
        {  //工艺单价管理
            path:'/craft',
            name:'craft',
            component: craft
        },
        {  //chatgpt聊天
            path:'/chatAI',
            name:'chatAI',
            component: chatAI
        },
        {  //采购金额
            path:'/purchase',
            name:'purchase',
            component: purchase
        },
        { //操作日志
            path:'/watcher',
            name:'watcher',
            component: watcher
        },
        { //问题负责人
            path: '/showcharger',
            name: 'showcharger',
            component: showcharger,
        },
        { //问题追踪
            path: '/issuetrace',
            name: 'issuetrace',
            component: issuetrace,
        },
        { //个人主页
            path: '/mainpage',
            name: 'mainpage',
            component: mainpage,
        },
        { //个人主页
            path: '/applyoutsider',
            name: 'applyoutsider',
            component: applyoutsider,
        },
        {
            path: '/agent',
            name: 'agent',
            component: agent
        },
        {
            path: '/cusstatus',
            name: 'cusstatus',
            component: customizedstatus
        },
        {
            path: '/dtlevel',
            name: 'dtlevel',
            component: dtlevel
        },
        {
            path: '/showvaluechain',
            name: 'showvaluechain',
            component: showvaluechain
        },
        {
            path: '/newkb',
            name: 'newkb',
            component: newkb
        }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/details',
        name: 'details',
        component: details
    },
    {
        path: '/contact',
        name: 'contact',
        component: contact
    },
    {
        path: '/help',
        name: 'help',
        component: help
    },   
    {
        path: '/hello',
        component: HelloWorld
    },

]

/**
 * 初始化路由 配置
 */
const router = createRouter({
    mode: 'history',
    base:'/',
    history: createWebHistory(),
    routes: routes
});

/**
 * 导出路由
 */
export default router
